module.exports = __webpack_public_path__ + "static/media/SupportIcons.59516bea.svg";